import { render } from "./PubSearchFacets.vue?vue&type=template&id=e8478e88"
import script from "./PubSearchFacets.vue?vue&type=script&lang=js"
export * from "./PubSearchFacets.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3522\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__